<script setup lang="ts">
import { getCurrentInstance } from 'vue';

import type { Product } from '@/types/products';

import ThePopupCard from '@/components/mode-map/ThePopupCard.vue';
import { i18n } from '@/shared-instance';

const props = withDefaults(
  defineProps<{
    product: Product;
    showFavorite?: boolean;
    prefixUrl: string | null;
  }>(),
  {
    showFavorite: true,
  },
);

const emit = defineEmits(['closePopup']);

i18n.install(getCurrentInstance()!.appContext.app);

function handleClose(event: PointerEvent) {
  event.preventDefault();
  emit('closePopup');
}
</script>

<template>
  <ThePopupCard
    :product="props.product"
    :prefix-url="props.prefixUrl"
    :show-favorite="props.showFavorite"
    :handle-close="handleClose"
  />
</template>
